<form autocomplete="off" nz-form [formGroup]="form" *ngIf="form">
  <nz-form-item class="!mb-0 !inline-flex w-full gap-1">
    <nz-form-control>
      <nz-select
        nzPlaceHolder="Search for an address"
        formControlName="search"
        [nzAllowClear]="true"
        [nzAutoFocus]="false"
        nzShowSearch
        autocomplete="off"
        nzServerSearch
        (click)="openSearchLocation.set(true)"
        [nzOpen]="openSearchLocation()"
        (nzOnSearch)="search$.next($event)"
        [nzLoading]="loading()"
        (keydown)="keyDown($event)"
        (ngModelChange)="setAddress($event)"
      >
        @if (loading()) {
          <nz-option nzDisabled nzCustomContent>
            <div class="inline-flex w-full gap-1">
              <nz-spin nzSize="small" class="block w-5" /> Loading...
            </div>
          </nz-option>
        } @else {
          @if (showHeadquarters) {
            <nz-option
              *ngFor="let item of headquarters"
              [nzValue]="item"
              [nzLabel]="item.query"
              nzCustomContent
            >
              <nz-tag [nzColor]="'blue'">Headquarters</nz-tag>
              {{ item.query.join(', ') }}
            </nz-option>
          }

          @if (predefined.length && !addresses.length) {
            <nz-option
              *ngFor="let item of predefined"
              [nzValue]="item"
              [nzLabel]="item.label"
              nzCustomContent
            >
              <nz-tag [nzColor]="'tomato'">Predefined</nz-tag>
              {{ item.label }}
            </nz-option>
          }

          <nz-option
            *ngFor="let item of addresses"
            [nzValue]="item"
            [nzLabel]="item.labels | join: ', '"
          ></nz-option>
        }
      </nz-select>
    </nz-form-control>

    <button
      nz-button
      nzType="default"
      [disabled]="loading()"
      nz-tooltip
      nzTooltipTitle="Open map"
      *ngIf="valid"
      (click)="openMap()"
    >
      <nz-icon nzType="environment" nzTheme="outline" />
    </button>
  </nz-form-item>

  <!-- Multi-input Address Fields -->
  <ng-container *ngIf="multiInputs">
    <div class="inline-flex gap-3 w-full justify-between mt-3">
      <nz-form-item class="w-full">
        <nz-form-label [nzRequired]="form.get('address1') | hasRequired">
          Address line 1
        </nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="address1"
            placeholder="Address line 1"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full">
        <nz-form-label [nzRequired]="form.get('address2') | hasRequired">
          Address line 2
        </nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="address2"
            placeholder="Address line 2"
          />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div class="inline-flex gap-3 w-full justify-between mt-0">
      <nz-form-item class="w-full mb-0">
        <nz-form-label [nzRequired]="form.get('postcode') | hasRequired">
          Post code
        </nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="postcode" placeholder="Post code" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label [nzRequired]="form.get('city') | hasRequired">
          City
        </nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="city" placeholder="City" />
        </nz-form-control>
      </nz-form-item>
    </div>
  </ng-container>
</form>
